import { render, staticRenderFns } from "./permissionsEditTable.vue?vue&type=template&id=451987a9&"
import script from "./permissionsEditTable.vue?vue&type=script&lang=ts&"
export * from "./permissionsEditTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports